
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "semantic-ui-react";
import { ProfilCode } from "../../model/dto/response";
import { OnboardingStatus } from "../../model/entities/onboarding-status";
import { AuthenticationState } from "../../model/state/authentication-state";
import { ApplicationState } from "../../store";
import { ButtonLink } from "../generic/button-link";
import { SimpleButton } from "../generic/simple-button";
import { userService } from "../../services/authentication-redux-service";
import { ResendValidationEmailBody } from "../../model/dto/body/resend-validation-email-body";
import { isScaModeActive } from "../../helpers/convert-env-variables-helper";
import { StatutSca } from "../../model/entities/statut-sca";

type Props = {
  status?: string,
  profil?: string,
  isMailValid?: boolean,
  wallet?: string,
  mangoPayId?: string
  isDon: boolean
};

export function ProjetDisclaimerProfil({status, profil, isMailValid, wallet, mangoPayId, isDon}: Props) {

  const loginProps: AuthenticationState = useSelector<ApplicationState,AuthenticationState>((state) => state.authentication);
  const [sent, setSent] = useState(false)
  const [showSentMessage, setShowSentMessage] = useState(false)

  const boxInfo = {
    display: "flex",
    alignContent: "center",
    background: "#FCF8E3",
    border:"solid 1px #ACACAC",
    borderRadius: "4px",
    padding: "15px 30px",
    marginBottom: "1.56rem",
    fontFamily:"raleway"
  }

  const title = {
    color: "#8A6D3B",
    fontSize: "25px",
    fontWeight: "bold",
    fontFamily:"raleway"
  }

  const description = {
    color: "#8A6D3B",
    fontSize: "16px",
    fontWeight: "bold",
    fontFamily:"raleway"
  } 

  const body : ResendValidationEmailBody = {
    IsClassique : true
  }

  return (
    <>
     {!isDon && loginProps?.user?.Etablissement === null && profil === ProfilCode.INVESTISSEUR && status === OnboardingStatus.PARTIELLEMENT_COMPLET && (!loginProps.user.IsAdressePostaleDone || !loginProps.user.IsIdentiteDone) &&
        <div style={boxInfo}>
          <div 
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4rem !important",
            }}
          >
            <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
          </div>
          <div style={{marginLeft: "1.2rem"}}>
            <h2 style={title}>Restez avec nous…</h2>
            <p style={description}>Vous devez soumettre vos informations d'identité et votre adresse postale pour pouvoir investir.​</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ButtonLink 
                label="Compléter mon profil"
                to="/profil"
              />
            </div>
          </div>
        </div>
      }

       {isScaModeActive && !isDon && loginProps?.user?.Etablissement === null && profil === ProfilCode.INVESTISSEUR && status === OnboardingStatus.PARTIELLEMENT_COMPLET && loginProps.user.IsAdressePostaleDone && loginProps.user.IsIdentiteDone && loginProps.user.StatutScaCode !== StatutSca.VALIDE && 
        <div style={boxInfo}>
          <div 
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4rem !important",
            }}
          >
            <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
          </div>
          <div style={{marginLeft: "1.2rem"}}>
            <h2 style={title}>Vous y êtes presque…</h2>
            <p style={description}>Pour investir, finalisez la vérification de votre compte sur votre page profil.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ButtonLink 
                label="Compléter mon profil"
                to="/profil"
              />
            </div>
          </div>
        </div>
      }

      {!isDon && loginProps?.user?.Etablissement === null && profil === ProfilCode.INVESTISSEUR &&
      (status === OnboardingStatus.PRESQUE_COMPLET || status === OnboardingStatus.ERREUR || status === OnboardingStatus.COMPLET || status === OnboardingStatus.VAL_EMAIL_A_FAIRE) && 
      !isMailValid &&
        <div style={boxInfo}>
         <div 
            css={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4rem !important",
            }}
          >
            <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
          </div>
          <div style={{marginLeft: "1.2rem"}}>
            <h2 style={title}>
              Validez votre adresse email en un clin d’œil pour investir.
            </h2>
            <p style={description}>
              Cliquez sur le bouton dans l’email que vous avez reçu pour valider votre adresse électronique. Pensez à vérifier vos courriers non-prioritaires ou indésirables.
            ​</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
            {
              !sent && !showSentMessage && (
                <SimpleButton 
                label="Renvoyer un email de validation" 
                onClick={() => 
                  userService.authenticatedAction(loginProps?.oauth).resendValidationEmail(body, loginProps.user?.UserId).then(response => {
                    if (response.IsTraitementOk) {
                      setSent(true)
                      setShowSentMessage(true)
                    }
                  })
                } 
              />
              )
            }
            {
              sent && showSentMessage && (
                <div>
                  <p style={{fontWeight:"bold", color: "#8A6D3B"}}>
                    Un nouvel email vient de vous être envoyé (pensez à vérifier vos spams)
                  </p>
              </div>
              )
            }
            </div>
          </div>
        </div>
      } 

     


      {/*  Partie donateur */}
      {isDon && loginProps?.user?.Etablissement !== null && profil === ProfilCode.INVESTISSEUR && status === OnboardingStatus.PARTIELLEMENT_COMPLET &&
        <div style={boxInfo}>
          <div 
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4rem !important",
            }}
          >
            <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
          </div>
          <div style={{marginLeft: "1.2rem"}}>
            <h2 style={title}>Vous y êtes presque...</h2>
            <p style={description}>Il manque quelques informations à votre profil pour vous permettre de réaliser votre don.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ButtonLink 
                label="Compléter mon profil"
                to="/profil"
              />
            </div>
          </div>
        </div>
      }

      {isDon && loginProps?.user?.Etablissement !== null && profil === ProfilCode.INVESTISSEUR &&
      (status === OnboardingStatus.PRESQUE_COMPLET || status === OnboardingStatus.ERREUR || status === OnboardingStatus.COMPLET || status === OnboardingStatus.VAL_EMAIL_A_FAIRE) && 
      !isMailValid &&
        <div style={boxInfo}>
         <div 
            css={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4rem !important",
            }}
          >
            <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
          </div>
          <div style={{marginLeft: "1.2rem"}}>
            <h2 style={title}>
              Validez votre adresse email en un clin d’œil pour donner.
            </h2>
            <p style={description}>
              Cliquez sur le bouton dans l’email que vous avez reçu pour valider votre adresse électronique. Pensez à vérifier vos courriers non-prioritaires ou indésirables.
            ​</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
            {
              !sent && !showSentMessage && (
                <SimpleButton 
                label="Renvoyer un email de validation" 
                onClick={() => 
                  userService.authenticatedAction(loginProps?.oauth).resendValidationEmail(body, loginProps.user?.UserId).then(response => {
                    if (response.IsTraitementOk) {
                      setSent(true)
                      setShowSentMessage(true)
                    }
                  })
                } 
              />
              )
            }
            {
              sent && showSentMessage && (
                <div>
                  <p style={{fontWeight:"bold", color: "#8A6D3B"}}>
                    Un nouvel email vient de vous être envoyé (pensez à vérifier vos spams)
                  </p>
              </div>
              )
            }
            </div>
          </div>
        </div>
      }
    
      
      {!isDon && loginProps?.user?.Etablissement === null && profil === ProfilCode.INVESTISSEUR && status === OnboardingStatus.PRESQUE_COMPLET && isMailValid && !wallet && !mangoPayId &&
        (
          <div style={boxInfo}>
            <div 
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1.4rem !important",
              }}
            >
              <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
            </div>
            <div css={{marginLeft: "1.2rem"}}>
              <h2 style={title}>
                Plus que quelques instants
              </h2>
              <p style={description}>
                Vos informations sont en cours de traitement auprès de notre prestataire, veuillez rafraichir la page d'ici quelques instants et vous pourrez investir</p>
              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
              </div>
            </div>
          </div>
        )
      }

      {isDon && loginProps?.user?.Etablissement !== null && profil === ProfilCode.INVESTISSEUR && status === OnboardingStatus.PRESQUE_COMPLET && isMailValid && !wallet && !mangoPayId &&
                (
          <div style={boxInfo}>
            <div 
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1.4rem !important",
              }}
            >
              <Icon name='warning sign' size='huge' css={{color: "#8A6D3B"}}/>
            </div>
            <div css={{marginLeft: "1.2rem"}}>
              <h2 style={title}>
                Plus que quelques instants
              </h2>
              <p style={description}>
                Vos informations sont en cours de traitement auprès de notre prestataire, veuillez rafraichir la page d'ici quelques instants et vous pourrez donner.</p>
              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
              </div>
            </div>
          </div>
        )
      }
    </>
  );
}
